import {
    LIST_INVESTOR_TRACKER,
    STORE_INVESTOR_TRACKER,
    STORE_LOCATION,
    REMOVE_LOCATION,
    STORE_PERSON,
    REMOVE_PERSON,
    SAVE_LOCATION,
    DELETE_LOCATION,
    SAVE_PERSON,
    DELETE_PERSON,
    SAVE_EXPENSE,
    DELETE_EXPENSE,
    SAVE_PAYMENT,
    DELETE_PAYMENT,
    UPDATE_PAYMENT_STATUS,
    UPDATE_PARTICIPATION,
    SAVE_CONTRACTOR,
    DELETE_CONTRACTOR,
    SAVE_QUOTE,
    DELETE_QUOTE,
    SAVE_CONTRACTOR_PAYMENT,
    DELETE_CONTRACTOR_PAYMENT,
    SAVE_WEEKLY_PAYMENT,
    DELETE_WEEKLY_PAYMENT,
    SAVE_SAVED_CONTRACTOR,
    DELETE_SAVED_CONTRACTOR,
    STORE_SAVED_CONTRACTOR,
    REMOVE_SAVED_CONTRACTOR,
} from '../../constants/investorTracker';

export const listInvestorTracker = (data) => ({ type: LIST_INVESTOR_TRACKER, data });

export const storeInvestorTracker = (payload) => ({ type: STORE_INVESTOR_TRACKER, payload });

export const storeLocation = (location) => ({ type: STORE_LOCATION, location });

export const removeLocation = (locationId) => ({ type: REMOVE_LOCATION, locationId });

export const storePerson = (person) => ({ type: STORE_PERSON, person });

export const removePerson = (personId) => ({ type: REMOVE_PERSON, personId });

export const saveLocation = (data, callback) => ({ type: SAVE_LOCATION, data, callback });

export const deleteLocation = (data, callback) => ({ type: DELETE_LOCATION, data, callback });

export const savePerson = (data, callback) => ({ type: SAVE_PERSON, data, callback });

export const deletePerson = (data, callback) => ({ type: DELETE_PERSON, data, callback });

export const saveExpense = (data, callback) => ({ type: SAVE_EXPENSE, data, callback });

export const deleteExpense = (data, callback) => ({ type: DELETE_EXPENSE, data, callback });

export const savePayment = (data, callback) => ({ type: SAVE_PAYMENT, data, callback });

export const deletePayment = (data, callback) => ({ type: DELETE_PAYMENT, data, callback });

export const updatePaymentStatus = (data, callback) => ({ type: UPDATE_PAYMENT_STATUS, data, callback });

export const updateParticipation = (data, callback) => ({ type: UPDATE_PARTICIPATION, data, callback });

export const saveContractor = (data, callback) => ({ type: SAVE_CONTRACTOR, data, callback });

export const deleteContractor = (data, callback) => ({ type: DELETE_CONTRACTOR, data, callback });

export const saveQuote = (data, callback) => ({ type: SAVE_QUOTE, data, callback });

export const saveContractorPayment = (data, callback) => ({ type: SAVE_CONTRACTOR_PAYMENT, data, callback });

export const deleteContractorPayment = (data, callback) => ({ type: DELETE_CONTRACTOR_PAYMENT, data, callback });

export const deleteQuote = (data, callback) => ({ type: DELETE_QUOTE, data, callback });

export const saveWeeklyPayment = (data, callback) => ({ type: SAVE_WEEKLY_PAYMENT, data, callback });

export const deleteWeeklyPayment = (data, callback) => ({ type: DELETE_WEEKLY_PAYMENT, data, callback });

export const saveSavedContractor = (data, callback) => ({ type: SAVE_SAVED_CONTRACTOR, data, callback });
export const deleteSavedContractor = (data, callback) => ({ type: DELETE_SAVED_CONTRACTOR, data, callback });
export const storeSavedContractor = (savedContractor) => ({ type: STORE_SAVED_CONTRACTOR, savedContractor });
export const removeSavedContractor = (savedContractorId) => ({ type: REMOVE_SAVED_CONTRACTOR, savedContractorId });
